export var darkHighContrastModeConfig = {
  colorDivider: '#eee',
  controlBorderColor: '#eee',
  controlBorderColorHover: '#eee',
  controlBorderColorSubtle: '#eee',
  surfaceBorderColor: '#eee'
};